import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { GisBoqWorkbenchService } from 'src/app/shared/services/gis-boq-workbench.service';

@Component({
  selector: 'app-gis-boq-params',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './gis-boq-params.component.html',
  styleUrls: ['./gis-boq-params.component.css'],
})
export class GisBoqParamsComponent implements OnInit, OnDestroy {
  private sub?: Subscription;

  constructor(readonly wb: GisBoqWorkbenchService) {}

  ngOnInit(): void {
    this.sub = this.wb.state$.subscribe();
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  onRouteChange(value: string): void {
    this.wb.setRoute(value ? Number(value) : null);
  }

  onChainageChange(): void {
    this.wb.setChainage(this.wb.startChainage, this.wb.endChainage);
  }

  onWidthChange(): void {
    this.wb.setWidths(Number(this.wb.laneWidthM) || 7, Number(this.wb.shoulderWidthM) || 0);
  }

  onMedianChange(value: string): void {
    this.wb.setMedian(value === 'concrete' ? 'concrete' : 'none');
  }
}
